import { render, staticRenderFns } from "./QuestionnaireShow.vue?vue&type=template&id=b7128b0a&scoped=true&"
import script from "./QuestionnaireShow.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7128b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
